// extracted by mini-css-extract-plugin
export default {"transaction_sec":"Transactions_transaction_sec__kG3lT","txtclr":"Transactions_txtclr__4NdIP","transaction_list":"Transactions_transaction_list__cVTbK"};